<rc-document-wrapper
  [documentItems$]="allSupplierInvoiceItems()"
  [documentType]="DocumentWrapperType.INVOICE"
  [entity]="supplierInvoice()"
  [loading]="isLoading() && !hasSections()"
  [notesCount]="notesBadgeCount()"
  [documentClass]="'full-height'"
>
  <ng-template #topbarTemplate>
    <div class="g-col-8">
      <rc-breadcrumbs />
      <rc-copyable-title [titleParts]="titleParts()" />
    </div>
    <div class="g-col-4">
      <rc-overview-create-button />
    </div>
  </ng-template>

  <ng-template #invoiceDocumentTemplate let-maxHeight class="d-flex flex-column flex-grow-1">
    @let invoice = supplierInvoice();
    @let invoiceDoNotInvoice = !!invoice?.doNotInvoice;
    @let invoiceLocked = supplierInvoiceIsLocked();
    @let currentTab = selectedTab();
    @let draftItems = allClientInvoiceDraftItems();
    @let lockedInvoiceItems = clientInvoiceItems();
    @let clientOrderItems = filteredClientOrderItems();
    @let effectiveMaxHeight = getMaxHeight(maxHeight);
      <div class="d-flex flex-column" [style.height.px]="!isMulti() ? maxHeight : null" [style.overflow]="!isMulti() ? 'hidden' : null">
      <div class="d-flex flex-column document-sections"
           [class.flex-grow-1]="isMulti()"
           [class.overflow-auto]="isMulti() && effectiveMaxHeight !== maxHeight"
           [style.max-height]="isMulti() ? effectiveMaxHeight + 'px' : null"
           [style.flex]="!isMulti() ? '1 1 50%' : null"
           [style.overflow-y]="!isMulti() ? 'auto' : null"
           [style.min-height]="!isMulti() ? '0' : null">
        @let sectionsList = visibleSections();
        @if (isMulti()) {
          <div
            class="grid template-cols-36 fc-neutral-800 w-100 align-items-center bg-neutral-100 header-grid gap-16 pt-16 pe-32 ps-32 pb-16 border-bottom-color-neutral-300 border-bottom-1">
            <div class="title-col"></div>
            <div class="meta-col">
              <kendo-checkbox
                #errorCheckbox
                [checkedState]="showOnlySectionsWithoutOrderOrNotFullyMapped()"
                (checkedStateChange)="showOnlySectionsWithoutOrderOrNotFullyMapped.set(!showOnlySectionsWithoutOrderOrNotFullyMapped())"></kendo-checkbox>
              <kendo-label
                class="k-checkbox-label"
                [for]="errorCheckbox"
                [text]="'SHOW_ONLY_ERROR_SECTIONS' | translate | capitalize"></kendo-label>
            </div>
            <div class="meta-col">
              <button kendoButton
                      class="link-button p-0 h-unset bg-transparent"
                      (click)="onAllToggleClick()">
                {{ allToggleLabel() | translate | capitalize }}
              </button>
            </div>
          </div>
        }
        @for (section of sectionsList; track section['@id']; let sectionIndex = $index) {
          @let sectionIri = section['@id']!;
          @let sectionFullyMapped = isSectionFullyMapped(section);
          @let sectionLinked = isSectionLinked(section);
          @let sectionHasActivity = hasSectionAnyMappingOrDoNotInvoice(section);
          @let sectionAllDoNotInvoice = isSectionAllDoNotInvoice(section);
          @let sectionItems = supplierInvoiceItemsSections()?.[sectionIri] ?? [];
          <div class="d-flex flex-column pt-32">
            <kendo-expansionpanel
              #panel="kendoExpansionPanel"
              class="document-section"
              [expanded]="!!sectionOpenStatus().get(sectionIri) || !isMulti()"
              (expandedChange)="toggleSection(sectionIri)"
            >
              <ng-template kendoExpansionPanelTitleDirective>
                <div
                  class="grid template-cols-36 fc-neutral-800 w-100 align-items-center bg-neutral-100 header-grid gap-16">
                  <div class="title-col">
                    <span class="d-flex gap-8 align-items-center">
                      @if (section.clientOrder) {
                        @if (isMulti() && sectionFullyMapped && !section.fullyProcessed) {
                          <kendo-checkbox
                            [checkedState]="checkedSectionIris().has(sectionIri)"
                            (checkedStateChange)="toggleSectionChecked(sectionIri)" />
                        }
                        @if (isMulti() && !sectionFullyMapped) {
                          <span class="d-flex fc-accents-red-500 fs-18 fw-600 gap-8 align-items-center">
                            <i class="rc-icon-exclamation-circle"></i>
                          </span>
                        }
                        @let markupClasses = section.clientOrder ? sectionFullyMapped ? 'fc-primary-500' : 'fc-accents-red-500' : 'fc-accents-red-500';

                        <a #client
                           class="rc-string-button !k-text-no-underline"
                           [href]="'/sales/orders' + section.clientOrder"
                           target="_blank"
                           >
                        <span class="!k-text-underline underline-offset-2 fs-18 fw-600" [class]="markupClasses">
                          {{ section.clientOrderDocumentNumber | uppercase }}
                        </span>

                      </a>
                      } @else {
                        @if (isMulti()) {
                          <span class="d-flex fc-accents-red-500 fs-18 fw-600 gap-8 align-items-center">
                            <i class="rc-icon-exclamation-circle"></i>{{ 'NOT_COUPLED' | translate | capitalize }}
                          </span>
                        } @else {
                          <span class="d-flex fs-18 fw-600 gap-8 fc-neutral-800 align-items-center">
                          {{ 'NOT_COUPLED' | translate | capitalize }}
                          </span>
                        }
                      }
                      @if (sectionHasActivity) {
                        <a
                          class="rc-string-button !k-text-no-underline"
                          [href]="'/sales/orders' + section.clientOrder"
                          target="_blank"
                          (click)="$event.stopPropagation()">
                          <i class="rc-icon-external-link !k-text-no-underline fs-16 ps-8 fc-neutral-600"
                             [class.hfc-primary-500]="sectionLinked && sectionFullyMapped"
                             [class.hfc-accents-red-500]="!sectionFullyMapped"></i>
                      </a>
                      } @else {
                        <button kendoButton
                                class="link-button !k-text-no-underline p-0 h-unset bg-transparent"
                                (click)="$event.stopPropagation(); updateLinkedOrder(section)"
                                [disabled]="invoiceLocked">
                          <i class="rc-icon-pencil !k-text-no-underline fs-16 ps-8 fc-neutral-600"
                             [class.hfc-primary-500]="sectionLinked && sectionFullyMapped"
                             [class.hfc-accents-red-500]="!sectionFullyMapped"></i>
                      </button>
                      }


                    </span>
                  </div>

                  <div class="meta-col">
                    @if (section.suggestedClientName) {
                      <span class="d-flex gap-8 align-items-center fc-neutral-800"><i
                        class="rc-icon-store fc-neutral-600"></i>{{ section.suggestedClientName | uppercase }}</span>
                    }
                  </div>

                  <div class="meta-col">
                    @if (section.reference) {
                      <span class="d-flex gap-8 align-items-center fc-neutral-800"><i
                        class="rc-icon-bookmark fc-neutral-600"></i>{{ section.reference | uppercase }}</span>
                    }
                  </div>

                  <div class="meta-col">
                    @if (section.documentDeliveryAddressString) {
                      <span class="d-flex gap-8 align-items-center fc-neutral-800"><i
                        class="rc-icon-truck-delivery fc-neutral-600"></i>{{ section.documentDeliveryAddressString }}</span>
                    }
                  </div>
                </div>
              </ng-template>
              <div class="d-flex flex-column p-0">
                <div cdkDropListGroup class="multi-document-template-wrapper">
                  <div class="multi-document-item-container">
                    <div class="multi-document-item-header grid template-cols-36 align-items-center gap-24">
                      <div class="k-column-title g-col-1" style="width: 32px"></div>
                      <div class="k-column-title g-col-6">{{ "ARTICLE" | translate | capitalize }}</div>
                      <div class="k-column-title g-col-6">{{ "DESCRIPTION" | translate | capitalize }}</div>
                      <div class="k-column-title g-col-4 !k-justify-content-end">{{ "VAT_PERCENTAGE" | translate | capitalize }}</div>
                      <div
                        class="k-column-title g-col-3 !k-justify-content-end">{{ "AMOUNT" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-3 !k-justify-content-end">{{ "TAX_EXCL_VAT" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-4 !k-justify-content-end">{{ "BASIC_NET" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-3 !k-justify-content-start">{{ "CONDITIONS" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-3 !k-justify-content-end">{{ "PURCHASE_PRICE" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-3 !k-justify-content-end">{{ "TOTAL" | translate | capitalize }}
                      </div>
                    </div>

                    <div class="multi-document-item-row">
                      @if (isSectionDataLoading(section)) {
                        <div class="section-loading-overlay">
                          <rc-list-skeleton [colAmount]="8" [forceCustomItemsPerPage]="true" [rowAmount]="section.supplierInvoiceItems.length"></rc-list-skeleton>
                        </div>
                      }
                      @for (item of sectionItems; track item['@id']; let
                        index = $index) {
                        @let itemIsFullyMapped = isItemFullyMapped(item, section);
                        @let itemIsPartiallyMapped = isItemPartiallyMapped(item, section);
                        <div
                          cdkDropList
                          [id]="'invoiceLine-' + item.id"
                          [cdkDropListConnectedTo]="['clientOrderList']"
                          [class.drop-disabled]="item.doNotInvoice || !droppableItemIris().has(item['@id']!) || invoiceDoNotInvoice"
                          (cdkDropListEntered)="isDraggingEntered = 'invoiceLine-' + item.id"
                          (cdkDropListExited)="isDraggingEntered = null"
                          [cdkDropListEnterPredicate]="enterPredicate"
                          (cdkDropListDropped)="onDropOnInvoiceLine($event, item, section)"
                          class="multi-document-item-wrapper">

                          <!-- SUPPLIER INVOICE ITEM -->
                          <div
                            [class.complete]="itemIsFullyMapped"
                            [class.partial]="itemIsPartiallyMapped"
                            class="grid template-cols-36 multi-document-item gap-24 g-col-12 {{ item.doNotInvoice ? 'fc-neutral-600': '' }}">
                            <div class="g-col-1" style="width: 32px;">
<!--                              @if (!(isSectionFullyMapped(section) && !isSectionAllDoNotInvoice(section))) {-->
                                <kendo-dropdownbutton
                                  [disabled]="((!section.clientOrder || section.fullyProcessed) && (sectionFullyMapped && !sectionAllDoNotInvoice)) || invoiceDoNotInvoice"
                                  class="no-bg-dropdown"
                                  iconClass="rc-icon-vertical-dots"
                                  [data]="item | actionMenuItems: menuItemsFn"
                                  (itemClick)="onActionMenuItemClick($event, item, section)">
                                </kendo-dropdownbutton>
<!--                              }-->
                            </div>

                            <div class="g-col-6 k-d-flex k-align-items-center" #articleNumberWrapper>
                              <div rcSelectableOverflow [wrapperElement]="articleNumberWrapper" class="k-d-flex k-flex-column">
                                <span class="article-number d-flex gap-8 align-items-center">
                                  {{ item.articleNumber }}

                                  @if (item.doNotInvoice) {
                                    <i class="rc-icon-no-invoice fc-neutral-600"></i>
                                  }
                                </span>
                                <span class="article-supplier">{{ item.brandName }}</span>
                              </div>
                            </div>
                            <div class="g-col-6 k-d-flex k-align-items-center" #descriptionWrapper>
                              <span rcSelectableOverflow [wrapperElement]="descriptionWrapper">{{ item.description }}</span>
                            </div>
                            <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
                              <span>{{ item.vatPercentage | percentage }}</span>
                            </div>
                            <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.amount | kendoNumber: amountFormat }}
                            </div>
                            <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.taxPrice | kendoNumber: decimalFormat }}
                            </div>
                            <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.basicNetPrice | kendoNumber: decimalFormat }}
                            </div>
                            <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-start">
                              {{ item.conditionString || '-' }}
                            </div>
                            <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
                              @let priceCheck = hasPriceMismatch(item, section);
                              @if (priceCheck.show) {
                                <i class="rc-icon-alert-triangle warning-price-cell"
                                   kendoPopoverAnchor
                                   #anchor="kendoPopoverAnchor"
                                   [showOn]="'hover'"
                                   [popover]="poMismatch">
                                </i>
                                <kendo-popover #poMismatch class="popover-bottom" position="left"
                                               [callout]="false"
                                               [offset]="35"
                                               [width]="216">
                                  <ng-template kendoPopoverBodyTemplate>
                                    <div class="popup-left">
                                      <div class="k-d-flex k-justify-content-between k-align-items-center">
                                        <span
                                          class="fw-400 k-color-primary-300">{{ 'ORDERED' | translate | capitalize }}</span>
                                        <span
                                          class="fw-600 k-color-base-white">{{ priceCheck.ordered | kendoNumber: decimalFormat }}</span>
                                      </div>
                                      <div class="k-d-flex k-justify-content-between k-align-items-center">
                                        <span
                                          class="fw-400 k-color-primary-300">{{ 'INVOICED' | translate | capitalize }}</span>
                                        <span
                                          class="fw-600 k-color-base-white">{{ priceCheck.invoiced | kendoNumber: decimalFormat }}</span>
                                      </div>
                                      <div class="k-d-flex k-justify-content-between k-align-items-center">
                                        <span
                                          class="fw-400 k-color-primary-300">{{ 'DIFFERENCE' | translate | capitalize }}</span>
                                        <span
                                          class="fw-600 k-color-base-white">{{ priceCheck.diff | kendoNumber: decimalFormat }}</span>
                                      </div>
                                    </div>
                                  </ng-template>
                                </kendo-popover>
                              }
                              {{ item.purchasePrice | kendoNumber: decimalFormat }}
                            </div>
                            <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.lineTotal | kendoNumber: decimalFormat }}
                            </div>

                          </div>

                          <!-- SUPPLIER INVOICE ITEM MAPPING -->
                          @let mappings = mappingsBySectionByItem().get(sectionIri)?.get(item['@id']!) ?? [];
                          @if (mappings.length > 0) {
                            @for (row of mappings; track row.mapping['@id']) {
                              @let mappedInvoiceItemMapping = row.mapping;
                              @let relatedClientOrderItem = row.clientOrderItem;
                              @if (relatedClientOrderItem) {
                                <div
                                  cdkDrag
                                  cdkDragLockAxis="y"
                                  (cdkDragStarted)="isDraggingMappedClientItem.set(true); onMappingDragStart(mappedInvoiceItemMapping, sectionIri)"
                                  [cdkDragData]="mappedInvoiceItemMapping"
                                  [cdkDragDisabled]="(currentTab !== 0 || invoiceLocked || !!mappedInvoiceItemMapping.clientInvoiceItem || isMulti()) || invoiceDoNotInvoice"
                                  class="grid template-cols-36 gap-24 mapped-document-item"
                                  [ngClass]="{ 'k-cursor-pointer': !invoiceLocked && !section.fullyProcessed && !invoiceDoNotInvoice }">

                                  <ng-template cdkDragPlaceholder>
                                    <div class="drag-drop-placeholder"
                                         style="height: 60px; width: calc(100% - 24px); margin-left: auto; margin-right: auto;"></div>
                                  </ng-template>
                                  @if (isMulti()) {
                                    <div class="g-col-1" style="width: 32px;">
<!--                                      @if (!(isSectionFullyMapped(section) && !isSectionAllDoNotInvoice(section))) {-->
                                        <kendo-dropdownbutton
                                          [disabled]="section.fullyProcessed || invoiceDoNotInvoice"
                                          class="no-bg-dropdown"
                                          iconClass="rc-icon-vertical-dots"
                                          [data]="mappedInvoiceItemMapping | actionMenuItems: mappedMenuItemsFn"
                                          (itemClick)="onActionMappedMenuItemClick($event, mappedInvoiceItemMapping, section)">
                                        </kendo-dropdownbutton>
<!--                                      }-->
                                    </div>
                                  } @else {
                                    <div class="g-col-1 k-d-flex k-align-items-center" style="width: 32px;">
                                      <button kendoButton
                                              [ngStyle]="{'visibility': currentTab === 1 || !!mappedInvoiceItemMapping.clientInvoiceItem  || invoiceDoNotInvoice ? 'hidden' : 'visible'}"
                                              class="!k-bg-transparent"
                                              iconClass="rc-icon-grip-vertical"></button>
                                    </div>
                                  }

                                  <div class="g-col-6 k-d-flex k-align-items-center">
                                    <div class="k-d-flex k-flex-column k-gap-1.5">
                                  <span class="article-number">
                                    {{ relatedClientOrderItem.articleNumber }}
                                    <a class="!k-color-black text-decoration-none"
                                       target="_blank"
                                       [href]="relatedClientOrderItem!.supplierArticle">
                                      <i class="ps-1 mt-auto rc-icon-external-link"></i>
                                    </a>
                                  </span>
                                      <span class="article-supplier">{{ relatedClientOrderItem!.brandName }}</span>
                                    </div>
                                  </div>
                                  <div class="g-col-6 k-d-flex k-align-items-center" #wrapper>
                                    <span rcSelectableOverflow [wrapperElement]="wrapper">{{ relatedClientOrderItem!.description }}</span>
                                  </div>
                                  <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
                                    <span>{{ relatedClientOrderItem.vatPercentage | percentage }}</span>
                                  </div>
                                  @let mappingForm = mappingForms.get(mappedInvoiceItemMapping['@id']!);
                                  @let showInput = mappingForm && !invoiceLocked && !mappedInvoiceItemMapping.clientInvoiceItem && !invoiceDoNotInvoice;
                                  @let overflowCheck = hasMappingAmountOverflow(mappedInvoiceItemMapping);
                                  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end gap-8" [class.pe-12]="!showInput">
                                    @if (overflowCheck.show) {
                                      <i class="rc-icon-alert-triangle warning-price-cell"
                                         kendoPopoverAnchor
                                         #overflowAnchor="kendoPopoverAnchor"
                                         (mouseenter)="showPopup(overflowAnchor)"
                                         (mouseleave)="hidePopup(overflowAnchor)"
                                         [popover]="poAmountOverflow">
                                      </i>
                                      <kendo-popover #poAmountOverflow class="popover-bottom" position="bottom" [offset]="7" [width]="216">
                                        <ng-template kendoPopoverBodyTemplate>
                                          <div class="k-d-flex k-justify-content-between k-align-items-center">
                                            <span class="fw-400 k-color-primary-300">{{ 'AMOUNT_ON_CLIENT_ORDER' | translate | capitalize }}</span>
                                            <span class="fw-600 k-color-base-white">{{ overflowCheck.ordered | kendoNumber: amountFormat }}</span>
                                          </div>
                                          <div class="k-d-flex k-justify-content-between k-align-items-center">
                                            <span class="fw-400 k-color-primary-300">{{ 'AMOUNT' | translate | capitalize }}</span>
                                            <span class="fw-600 k-color-base-white">{{ overflowCheck.mapped | kendoNumber: amountFormat }}</span>
                                          </div>
                                        </ng-template>
                                      </kendo-popover>
                                    }
                                    @if (showInput) {
                                      <form [formGroup]="mappingForm">
                                        <kendo-numerictextbox
                                          formControlName="amount"
                                          [format]="amountFormat"
                                          [decimals]="amountDecimals"
                                          [min]="1"
                                          [max]="getMaxAllowedAmount(mappedInvoiceItemMapping)"
                                          (blur)="onMappingAmountBlur(mappedInvoiceItemMapping)"
                                          [spinners]="false"
                                          [autoCorrect]="true">
                                        </kendo-numerictextbox>
                                      </form>
                                    } @else {
                                      <span>
                                        {{ mappedInvoiceItemMapping.amount | kendoNumber: amountFormat }}
                                      </span>
                                    }
                                  </div>
                                  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
                                    {{ relatedClientOrderItem!.taxPrice | kendoNumber: decimalFormat }}
                                  </div>
                                  <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
                                    {{ relatedClientOrderItem!.basicNetPrice | kendoNumber: decimalFormat }}
                                  </div>
                                  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-start">
                                    {{ relatedClientOrderItem!.conditionString || '-' }}
                                  </div>
                                  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
                                    {{ relatedClientOrderItem!.purchasePrice | kendoNumber: decimalFormat }}
                                  </div>
                                  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
                                    {{ relatedClientOrderItem!.lineTotal | kendoNumber: decimalFormat }}
                                  </div>
                                </div>
                              }
                            }
                          } @else {
                            <div
                              cdkDrag
                              cdkDragLockAxis="y"
                              (cdkDragStarted)="isDraggingMappedClientItem.set(true)"
                              (cdkDragEnded)="fallbackEnd()"
                              [cdkDragDisabled]="currentTab !== 0"
                              class="grid template-cols-36"
                              style="position: relative; background-color: transparent;"
                              [ngClass]="(isDraggingEntered === 'invoiceLine-' + item.id) ? '' : 'visible-hidden'">

                              <ng-template cdkDragPlaceholder>
                                <div class="drag-drop-placeholder"
                                     style="height: 60px; width: calc(100% - 24px); margin-left: auto; margin-right: auto;"></div>
                              </ng-template>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>


              </div>
            </kendo-expansionpanel>
          </div>
        }
      </div>
      @if (!isMulti()) {
        <div #tabContainer class="multi-document-tab-container pt-48 pe-32 ps-32" style="flex: 1 1 50%; overflow-y: auto; min-height: 0">
          <kendo-tabstrip (tabSelect)="onTabSelect($event)" class="no-px-32">
            <kendo-tabstrip-tab [selected]="currentTab === 0">
              <ng-template kendoTabTitle>
                  <span>
                    <i class="rc-icon-clipboard-list"></i>
                    {{ "CLIENT_ORDER" | translate | capitalize }}
                    <span class="amount">{{ clientOrderItems.length }}</span>
                  </span>
              </ng-template>

              <ng-template kendoTabContent>
                @if (currentTab === 0) {
                  <div class="tab-container link-document-item-container"
                       [attr.inert]="currentTab !== 0 ? '' : null">
                    <!-- Header -->
                    <div class="grid template-cols-36 gap-24 align-items-center link-document-item-header"
                         style="padding-bottom: 16px;">
                      <div class="k-column-title g-col-1" style="width: 32px"></div>
                      <div class="k-column-title g-col-8">{{ "ARTICLE_NUMBER" | translate | capitalize }}</div>
                      <div
                        class="k-column-title g-col-6 !k-justify-content-end">{{ "BILLED" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-3 !k-justify-content-end">{{ "AMOUNT" | translate | capitalize }}
                      </div>

                      <div
                        class="k-column-title g-col-4 !k-justify-content-end">{{ "BASIC_PRICE" | translate | capitalize }}
                      </div>
                      <div class="k-column-title g-col-4 !k-justify-content-start">{{ "DISCOUNTS" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-4 !k-justify-content-end">{{ "NET_PRICE" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-2 !k-justify-content-end">{{ "TAX_EXCL_VAT" | translate | capitalize }}
                      </div>
                      <div
                        class="k-column-title g-col-4 !k-justify-content-end">{{ "TOTAL" | translate | capitalize }}
                      </div>
                    </div>

                    <!-- Client Order Drop List -->
                    <div
                      cdkDropList
                      id="clientOrderList"
                      class="link-document-item-row"
                      [cdkDropListConnectedTo]="invoiceLineIds()"
                      [cdkDropListSortingDisabled]="false"
                      [cdkDropListDisabled]="readonly()"
                      (cdkDropListDropped)="onDropBackToClientOrderList($event)"
                      (cdkDropListEntered)="clientOrderDropzoneEntered = true"
                      (cdkDropListExited)="clientOrderDropzoneEntered = false"
                    >
                      @let items = clientOrderItems;
                      @let hasClientOrder = !!sections()?.[0]?.clientOrder;
<!--                      @let firstSectionIri = sections()?.[0]?.['@id'];-->
<!--                      @let hasAnyClientItems = ((clientOrderItemsBySectionByIri().get(firstSectionIri || '')?.size ?? 0) > 0);-->


                      <!-- Render items if present -->
                      @if ((items?.length ?? 0) > 0) {
                        @for (item of items; track item['@id']; let index = $index) {
                          @let color = getColorClass(item);
                          <div
                            cdkDrag
                            cdkDragLockAxis="y"
                            [cdkDragData]="item"
                            [cdkDragDisabled]="invoiceLocked || invoiceDoNotInvoice"
                            class="grid template-cols-36 link-document-item gap-24 w-100 {{ color }}"
                            [ngClass]="{ 'k-cursor-pointer': !invoiceLocked && !invoiceDoNotInvoice }"
                          >
                            <ng-template cdkDragPlaceholder>
                              <div class="drag-drop-placeholder"
                                   style="height: 60px; width: calc(100% - 24px); margin: 0 auto;"></div>
                            </ng-template>

                            <div class="g-col-1 k-d-flex k-align-items-center" style="width: 32px;">
                              <button kendoButton class="!k-bg-transparent"
                                      [ngStyle]="{'visibility': invoiceDoNotInvoice ? 'hidden' : 'visible'}"
                                      iconClass="rc-icon-grip-vertical"></button>
                            </div>

                            <div class="g-col-8 k-d-flex k-align-items-center">
                              <div class="k-d-flex k-flex-column k-gap-1.5">
                                <span class="article-number">
                                  {{ item.articleNumber }}
                                  <a class="!k-color-black text-decoration-none" target="_blank"
                                     [href]="item.supplierArticle">
                                    <i class="ps-1 mt-auto rc-icon-external-link"></i>
                                  </a>
                                </span>
                                <span class="article-supplier">{{ item.brandName }}</span>
                              </div>
                            </div>
                            <div class="g-col-6 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.mappedAmount | kendoNumber: amountFormat }}
                            </div>
                            <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.amount | kendoNumber: amountFormat }}
                            </div>


                            <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.basicNetPrice | kendoNumber: decimalFormat }}
                            </div>
                            <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-start">
                              {{ item.conditionString || '-' }}
                            </div>
                            <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.purchasePrice | kendoNumber: decimalFormat }}
                            </div>
                            <div class="g-col-2 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.taxPrice | kendoNumber: decimalFormat }}
                            </div>

                            <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
                              {{ item.lineTotal | kendoNumber: decimalFormat }}
                            </div>
                          </div>
                        }
                      } @else {
                        <!-- Empty drop zone always rendered when no items (keeps DOM stable & accepts drops) -->
                        @if (hasClientOrder) {
                          <div class="empty-drop-zone"
                               [class.active]="clientOrderDropzoneEntered"
                               aria-label="Drop items here"></div>
                        }
                        @else {
                          <div class="k-d-flex k-justify-content-center k-align-items-center k-py-6">
                            <div class="k-d-flex k-justify-content-center k-align-items-center k-flex-col k-gap-3">
                              <div class="empty-entity-icon-wrapper"><i class="rc-icon-clipboard-list"></i></div>
                              <div class="empty-rows">
                                {{
                                  "NO_ENTITY_ITEMS"
                                    | translate: { entity: ("CLIENT_ORDER_ITEMS" | translate) }
                                    | translate
                                    | capitalize
                                }}
                              </div>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  </div>
                  @if (isClientOrderListLoading()) {
                    <div class="section-loading-overlay">
                      <rc-list-skeleton [colAmount]="8" [forceCustomItemsPerPage]="true" [rowAmount]="3"></rc-list-skeleton>
                    </div>
                  }
                }
              </ng-template>

            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab [selected]="currentTab === 1">
              <ng-template kendoTabTitle>
                  <span>
                    <i class="rc-icon-sales-invoice"></i>
                    {{ "CLIENT_INVOICE" | translate | capitalize }}
                    <span class="amount">
                      {{ invoiceLocked ? lockedInvoiceItems.length : draftItems.length }}
                    </span>
                  </span>
              </ng-template>
              <ng-template kendoTabContent>
                @if (currentTab === 1) {
                  @if (draftItems.length === 0 && !invoiceLocked) {
                    <div class="k-d-flex k-justify-content-center k-align-items-center k-h-full"
                         [attr.inert]="currentTab !== 1 ? '' : null">
                      <div class="k-d-flex k-justify-content-center k-align-items-center k-flex-col k-gap-3">
                        <div class="empty-entity-icon-wrapper"><i class="rc-icon-row-insert-bottom"></i></div>
                        <div class="empty-rows">
                          {{ "NO_ENTITY_ITEMS_FOUND" | translate: { entity: "CLIENT_INVOICE_DRAFT_ITEMS" | translate } | translate | capitalize }}
                        </div>
                        <div class="grid-action">
                          <button kendoButton [type]="'button'" class="link-button"
                                  (click)="createDrafts(sections()![0])">
                            {{
                              "CREATE_DRAFT_ITEMS"
                                | translate
                                | capitalize
                            }}
                          </button>
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="tab-container link-document-draft-item-container"
                         [attr.inert]="currentTab !== 1 ? '' : null">
                      <div class="grid template-cols-36 align-items-center link-document-draft-item-header"
                           style="padding-bottom: 16px;">
                        <div class="k-column-title g-col-1" style="width: 32px"></div>
                        <div class="k-column-title g-col-4">{{ "ARTICLE_NUMBER" | translate | capitalize }}</div>
                        <div class="k-column-title g-col-6">{{ "TYPE_NUMBER" | translate | capitalize }}</div>
                        <div class="k-column-title g-col-3 !k-justify-content-end">
                          {{ "RETAIL_PRICE" | translate | capitalize }}
                        </div>
                        <div class="k-column-title g-col-2 !k-justify-content-end">
                          {{ "VAT" | translate | capitalize }}
                        </div>
                        <div class="k-column-title g-col-3 !k-justify-content-end">
                          {{ "AMOUNT" | translate | capitalize }}
                        </div>
                        <div class="k-column-title g-col-3 !k-justify-content-end">{{ "TAX_EXCL_VAT" | translate | capitalize }}
                        </div>
                        <div
                          class="k-column-title g-col-4 !k-justify-content-end">{{ "BASIC_NET" | translate | capitalize }}
                        </div>
                        <div
                          class="k-column-title g-col-3 !k-justify-content-start">{{ "CONDITIONS" | translate | capitalize }}
                        </div>
                        <div
                          class="k-column-title g-col-3 !k-justify-content-end">{{ "SALES" | translate | capitalize }}
                        </div>
                        <div
                          class="k-column-title g-col-4 !k-justify-content-end">{{ "TOTAL" | translate | capitalize }}
                        </div>
                      </div>
                      <div class="link-document-draft-item-row">
                        <div class="link-document-draft-item-wrapper">
                          @if (draftItems.length !== 0 && !invoiceLocked) {
                            <!-- CLIENT INVOICE ITEM MAPPING  -->
                            @let readOnlyMap = draftAmountReadOnlyByIri();
                            @for (draftItem of draftItems; track draftItem['@id']) {
                              <rc-client-invoice-draft-item
                                [disabled]="invoiceDoNotInvoice"
                                [supplier]="invoice!.supplier"
                                [clientInvoiceDraftItem]="draftItem"
                                [max]="getMaxForDraftItem(draftItem)"
                                [amountReadOnly]="readOnlyMap.get(draftItem['@id']!) ?? false"
                                (update)="updateDraftItems(sections()![0])">
                              ></rc-client-invoice-draft-item>
                            }
                            @if (draftItems.length && !invoiceLocked && !invoiceDoNotInvoice) {
                              <span class="k-d-flex k-justify-content-end k-align-items-center k-gap-2 k-py-4">
                                <i class="rc-icon-trash k-color-primary k-font-size-xl"></i>
                                <a (click)="deleteDrafts()"
                                   class="rc-string-button">
                                {{ 'DELETE_ENTITY' | translate:{ entity: ('CLIENT_INVOICE_DRAFT_ITEMS' | translate) } | capitalize }}
                              </a>
                            </span>
                            }
                          } @else if (lockedInvoiceItems.length !== 0 && invoiceLocked) {
                            <!-- CLIENT INVOICE ITEM  -->
                            @for (item of lockedInvoiceItems; track item['@id']) {
                              <rc-client-invoice-item
                                [clientInvoiceItem]="item"
                              ></rc-client-invoice-item>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  }
                }
              </ng-template>
            </kendo-tabstrip-tab>
            @let clientName = activeClientName();
            @if(clientName) {
              <kendo-tabstrip-tab [disabled]="true" [class.ms-auto]="true" [cssClass]="'ms-auto opacity-1'">
                <ng-template kendoTabTitle [class.ms-auto]="true">
                  <span><i class="rc-icon-store opacity-1 fc-neutral-800 pe-8"></i><span class="fc-neutral-800 opacity-1">{{clientName | uppercase}}</span></span>
<!--                  <rc-badge [icon]="'rc-icon-store'" [label]="draft.clientName | capitalize" [color]="BadgeColor.GREEN"></rc-badge>-->
                </ng-template>

                <ng-template kendoTabContent>
                  </ng-template>
              </kendo-tabstrip-tab>
            }
          </kendo-tabstrip>
        </div>
      }
      </div>
  </ng-template>

  <ng-template #documentFooterTemplate let-notesVisible="notesVisible" let-toggleTemplate="toggleTemplate">
    <div class="d-flex flex-column w-100 pb-32 mt-auto pe-32 ps-32 pt-16">
      @if (supplierInvoice() && notesVisible) {
        <form class="d-flex w-100" [formGroup]="supplierInvoiceForm">
          <div class="grid w-100">
            <div class="d-flex flex-column g-col-12 g-col-lg-6">
              <kendo-formfield showHints="initial" showErrors="initial">
                <kendo-label
                  labelCssClass="k-form-label"
                  [for]="clientOrderInternalNote"
                  [text]="'CLIENT_ORDER_NOTE' | translate | uppercase"></kendo-label>
                <kendo-textarea
                  [value]="supplierInvoice().clientOrderInternalNotes?.join('\n') ?? ''"
                  [rows]="3"
                  [disabled]="true"
                  #clientOrderInternalNote></kendo-textarea>
              </kendo-formfield>
            </div>
            <div class="d-flex flex-column g-col-12 g-col-lg-6">
              <kendo-formfield showHints="initial" showErrors="initial">
                <kendo-label
                  labelCssClass="k-form-label"
                  [for]="internalNote"
                  [text]="'NOTE_SALES' | translate | uppercase"></kendo-label>
                <kendo-textarea
                  [rows]="3"
                  (valueChange)="updateSupplierInvoice('internalNote')"
                  rcValidation
                  controlType="textArea"
                  formControlName="internalNote"
                  #internalNote></kendo-textarea>
              </kendo-formfield>
            </div>
          </div>
        </form>
      }


        <div class="d-flex gap-8 align-self-end mt-32">
          <ng-container *ngTemplateOutlet="toggleTemplate"></ng-container>
          @if (state()) {
            <div class="d-flex gap-0">
              <button type="button"
                      class="gap-8 ms-auto border-top-right-radius-0 border-bottom-right-radius-0 bg-neutral-100 border-color-neutral-300 border-top-1 border-left-1 border-bottom-1 border-right-0"
                      kendoButton (click)="previous()" [disabled]="state()!.index === 0">
                <span class="d-flex gap-8 align-items-center"><i class="rc-icon-arrow-left fs-16 fc-neutral-600"></i> <span
                  class="fw-500">{{ "PREVIOUS_ENTITY" | translate: { entity: "SUPPLIER_INVOICE" | translate } | capitalize }}</span></span>
              </button>
              <button type="button" class="gap-8 ms-auto border-radius-0 bg-neutral-100 border-color-neutral-300 border-1"
                      kendoButton (click)="cancelButton()" (contextmenu)="onOverviewContextMenu($event)" (auxclick)="onAuxClick($event)">
                <span class="d-flex gap-8 align-items-center"><i class="rc-icon-list fs-16 fc-neutral-600 "></i> <span
                  class="fw-500">{{ "OVERVIEW" | translate | capitalize }}</span></span>
              </button>
              <button type="button"
                      class="gap-8 ms-auto align-items-center border-top-left-radius-0 border-bottom-left-radius-0 bg-neutral-100 border-color-neutral-300 border-left-0 border-top-1 border-bottom-1 border-right-1"
                      kendoButton (click)="next()" [disabled]="state()!.index === state()!.idsOnPage.length -1">
                <span class="d-flex gap-8 align-items-center"><span
                  class="fw-500">{{ "NEXT_ENTITY" | translate: { entity: "SUPPLIER_INVOICE" | translate } | capitalize }}</span> <i
                  class="rc-icon-arrow-right fs-16 fc-neutral-600"></i></span>
              </button>
            </div>
          } @else {
            <button type="button" class="me-2 ms-auto rc-cancel-button" kendoButton fillMode="link" (click)="cancelButton()" (contextmenu)="onOverviewContextMenu($event)" (auxclick)="onAuxClick($event)">
              {{ (supplierInvoice() ? "BACK_TO_OVERVIEW" : "CANCEL") | translate | capitalize }}
            </button>
          }
        </div>
    </div>
  </ng-template>

  <ng-template cdkDragPlaceholder>
    <div class="g-col-36 drag-drop-placeholder" style="height: 60px;"></div>
  </ng-template>

  <ng-template #sidebarTemplate>
    <rc-supplier-invoice-totals [supplierInvoice]="supplierInvoice()"></rc-supplier-invoice-totals>
    <rc-supplier-invoice-sidebar-panel
      [readonly]="readonly()"
      (updateTotals)="updateTotals()"
      [supplierInvoice]="supplierInvoice()"
      class="d-flex flex-column flex-grow-1" />
  </ng-template>
</rc-document-wrapper>
